import { Dimensions, StyleSheet } from 'react-native'
import theme from '../../../theme'

const width = Dimensions.get('window').width

const styles = StyleSheet.create({
    container: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'white',
    },
    header: {
        fontSize: 16,
        fontWeight: 'bold',
        color: theme.colors.textPrimary,
        textAlign: 'center',
        marginTop: 10,
    },
    subHeader: {
        fontSize: 15,
        fontWeight: 'normal',
        color: theme.colors.textPrimary,
        textAlign: 'center',
        marginTop: 4,
        marginBottom: 12,
        marginHorizontal: 12,
    },
    containerItem: {
        flex: 1,
        flexDirection: 'row',
        alignItems: 'center',
        marginHorizontal: 10,
    },
    image: {
        width: width / 5,
        height: width / 5,
        aspectRatio: 1,
        alignSelf: 'flex-start',
    },
    title: {
        fontSize: 16,
        fontWeight: 'bold',
        color: theme.colors.textPrimary,
        textAlign: 'left',
    },
    description: {
        fontSize: 15,
        fontWeight: 'normal',
        color: theme.colors.textSecondary,
        textAlign: 'left',
        marginVertical: 5,
    },
    containerMinMax: {
        flexDirection: 'row',
        justifyContent: 'flex-start',
    },
    counter: {
        fontSize: 14,
        fontWeight: '500',
        color: theme.colors.textSecondary,
    },
    number: {
        fontSize: 15,
        fontWeight: '500',
        color: theme.colors.textPrimary,
    },
    containerInfo: {
        flex: 2.5,
        alignSelf: 'center',
        justifyContent: 'flex-start',
        marginHorizontal: 10,
    },
    containerData: {
        width: '100%',
        height: 150,
        alignItems: 'center',
        backgroundColor: theme.colors.filtersBackground,
        borderTopLeftRadius: 20,
        borderTopRightRadius: 20,
    },
    info: {
        fontSize: 16,
        fontWeight: 'bold',
        color: theme.colors.colorSecondary,
        paddingTop: 12,
    },
    detail: {
        fontSize: 15,
        fontWeight: 'normal',
        color: theme.colors.textSecondary,
        marginVertical: 10,
    },
    buttonContainer: {
        flexDirection: 'column',
        position: 'absolute',
        padding: 15,
        bottom: 15,
        width: '100%',
    },
    mainButton: {
        width: '100%',
        height: 40,
        backgroundColor: theme.colors.colorPrimary,
        padding: 10,
        borderRadius: 10,
        alignItems: 'center',
        justifyContent: 'center',
    },
    mainButtonText: {
        fontSize: 16,
        color: 'white',
        fontWeight: 'bold',
        textAlign: 'center',
    },
    containerNumberPicker: {
        flex: 1,
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
    },
    containerSign: {
        width: 25,
        height: 25,
        borderWidth: 1,
        borderRadius: 5,
        borderColor: theme.colors.colorPrimary,
        alignContent: 'center',
        alignItems: 'center',
        justifyContent: 'center',
    },
    sign: {
        fontSize: 20,
        fontWeight: 'bold',
        alignItems: 'center',
        alignContent: 'center',
        alignSelf: 'center',
        textAlign: 'center',
    },
    dividerHorizontalLine: {
        borderBottomWidth: 0.5,
        borderBottomColor: theme.colors.lightGray,
        width: '100%',
        marginVertical: 10,
    },
    spacer: {
        height: 40,
    },
})

export default styles
